import React from 'react';
import { Alert, AlertIcon, Button, Text } from '@chakra-ui/react';

/** Event invitee list: explains why some invitees are deactivated CRM contacts, with a filter toggle. */
const DeactivatedInviteesNotice: React.FC<{
  count: number;
  active: boolean;
  onToggle: () => void;
}> = ({ count, active, onToggle }) => {
  if (count <= 0) return null;
  return (
    <Alert status="warning" variant="left-accent" data-testid="deactivated-invitees-notice" mb={3} flexWrap="wrap">
      <AlertIcon />
      <Text fontSize="sm" flex="1" minW="200px">
        {count === 1
          ? "1 invité est un contact désactivé (supprimé du CRM). Il conserve son historique d'invitation mais ne recevra plus de nouveaux e-mails."
          : `${count} invités sont des contacts désactivés (supprimés du CRM). Ils conservent leur historique d'invitation mais ne recevront plus de nouveaux e-mails.`}
      </Text>
      <Button
        size="xs"
        data-testid="deactivated-invitees-chip"
        aria-pressed={active}
        colorScheme="orange"
        variant={active ? 'solid' : 'outline'}
        onClick={onToggle}
      >
        {active ? 'Afficher tous les invités' : 'Contacts désactivés uniquement'}
      </Button>
    </Alert>
  );
};

export default DeactivatedInviteesNotice;
